export default "__VITE_ASSET__9ce357b9__"